import { render, staticRenderFns } from "./ServiceRequestDetails.vue?vue&type=template&id=6d16eb72&scoped=true"
import script from "./ServiceRequestDetails.vue?vue&type=script&lang=ts"
export * from "./ServiceRequestDetails.vue?vue&type=script&lang=ts"
import style0 from "./ServiceRequestDetails.vue?vue&type=style&index=0&id=6d16eb72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d16eb72",
  null
  
)

export default component.exports